import { createContext, useContext } from 'react';

import type { AdminCatalogApi } from '../api';

export const AdminCatalogContext = createContext<AdminCatalogApi | null>(null);

export function useAdminCatalogApi() {
  const value = useContext(AdminCatalogContext);
  if (!value) throw new Error('useAdminCatalogApi must be used within AdminCatalogProvider.');
  return value;
}
